<script setup>
import { storeToRefs } from 'pinia'
import LinkIos from '@/assets/logos/ios.svg?url'
import LinkAndroid from '@/assets/logos/android.svg?url'
import { useMessageStore } from '@/stores/messages'

const props = defineProps({
    appDownloadButtonBarConfig: {
        type: Object,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                iosLink: value => value?.iosLink === undefined || typeof value?.iosLink === 'string',
                androidLink: value => value?.androidLink === undefined || typeof value?.androidLink === 'string',
                trackingContext: value => value?.trackingContext === undefined || typeof value?.trackingContext === 'string'
            }

            return Object.entries(validations).every(([_, validation]) => validation(rawValue))
        }
    }
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

/**
 * Tracks a click event in the application store.
 *
 * @param {string} store - The name of the store to track.
 * @return {void} This function does not return a value.
 */

const trackClick = (store) => {
    if (!props.appDownloadButtonBarConfig.trackingContext) {
        return
    }

    // Track user click
    trackPageLoad({
        eventName: TRACKING_CONSTANTS.CLICK_EVENTS.APPSTORE_CLICK,
        elementContext: props.appDownloadButtonBarConfig.trackingContext,
        appProvider: store
    })
}
</script>

<template>
    <div class="app-download-button-bar-default">
        <NuxtLink
            class="ios-link"
            :to="appDownloadButtonBarConfig?.iosLink"
            :title="staticKeys?.footer_appteaser_ios_alt_web"
            target="_blank"
            rel="noopener noreferrer"
            data-vitest="app-store-button"
            @click="trackClick('app_store')"
        >
            <img :src="LinkIos" :alt="staticKeys?.footer_appteaser_ios_alt_web" width="140" height="42">
        </NuxtLink>
        <NuxtLink
            class="android-link"
            :to="appDownloadButtonBarConfig?.androidLink"
            :title="staticKeys?.footer_appteaser_android_alt_web"
            target="_blank"
            rel="noopener noreferrer"
            data-vitest="google-play-store-button"
            @click="trackClick('google_play')"
        >
            <img :src="LinkAndroid" :alt="staticKeys?.footer_appteaser_android_alt_web" width="140" height="42">
        </NuxtLink>
    </div>
</template>

<style lang="scss">
.app-download-button-bar-default {
    .ios-link {
        margin-inline-end: px2rem(16);
    }
}
</style>
